import { combineReducers } from '@reduxjs/toolkit';

import {
  AssignTicketsState,
  reducer as assignTicketsReducer,
} from '../features/assign-tickets/assign-tickets-reducer';
import authenticationReducer, {
  AuthenticationSliceState,
} from '../features/authentication/authentication-reducer';
import { State as EventDetailsState } from '../features/event-details/event-detail-types';
import eventDetailsReducer from '../features/event-details/event-details-reducer';
import manageStepReducer, {
  State as StepSliceState,
} from '../features/manage-steps/manage-steps-reducer';
import {
  reducer as registrationCompleteReducer,
  RegistrationCompleteState,
} from '../features/registration-complete/registration-complete-reducer';
import { reducer as registrationFormReducer } from '../features/registration-form/registration-form-reducer';
import type { State as FormAnswersState } from '../features/registration-form/registration-form-types';
import cartReducer from '../features/select-tickets/cart-reducer';
import { State as CartState } from '../features/select-tickets/cart-types';
import { seriesCartReducer } from '../features/series-select-events/series-cart-reducer';
import {
  seriesReducer,
  SeriesSliceState,
} from '../features/series-select-events/series-reducer';
import {
  reducer as sessionReducer,
  SessionsState,
} from '../features/sessions/sessions-reducer';

export interface RootState {
  authentication: AuthenticationSliceState;
  steps: StepSliceState;
  eventDetails: EventDetailsState;
  cart: CartState;
  registrationForm: FormAnswersState;
  assignTickets: AssignTicketsState;
  registrationComplete: RegistrationCompleteState;
  sessions: SessionsState;
  series: SeriesSliceState;
  seriesCart: ReturnType<typeof seriesCartReducer>;
}

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  steps: manageStepReducer,
  eventDetails: eventDetailsReducer,
  cart: cartReducer,
  registrationForm: registrationFormReducer,
  assignTickets: assignTicketsReducer,
  registrationComplete: registrationCompleteReducer,
  sessions: sessionReducer,
  series: seriesReducer,
  seriesCart: seriesCartReducer,
});

// eslint-disable-next-line import/no-default-export
export default rootReducer;
